import { useState } from "react";

interface Community {
  name: string;
  route: string;
}

interface Subregion {
  name: string;
  description: string;
  communities: Community[];
  hub: { name: string; route: string };
}

interface Region {
  id: string;
  name: string;
  icon: string;
  subregions: Subregion[];
}

const regions: Region[] = [
  {
    id: "los-angeles",
    name: "Los Angeles Metro",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "Westside & Beach Cities",
        description: "Santa Monica, Venice, Marina del Rey, and Pacific Palisades — all within 15 minutes of LAX on the 405 or 10. Brentwood and Bel Air are adjacent to the 405 corridor. Culver City is a central hub.",
        hub: { name: "Los Angeles", route: "/cities/los-angeles" },
        communities: [
          { name: "Santa Monica", route: "/cities/santa-monica" }, { name: "Venice", route: "#" },
          { name: "Marina del Rey", route: "#" }, { name: "Pacific Palisades", route: "#" },
          { name: "Brentwood", route: "#" }, { name: "Bel Air", route: "#" },
          { name: "Westwood", route: "#" }, { name: "Culver City", route: "#" },
          { name: "Playa del Rey", route: "#" }, { name: "El Segundo", route: "#" },
          { name: "Manhattan Beach", route: "#" }, { name: "Hermosa Beach", route: "#" },
          { name: "Redondo Beach", route: "#" }, { name: "Palos Verdes", route: "#" },
        ],
      },
      {
        name: "San Fernando Valley",
        description: "Burbank, Glendale, Pasadena, and Studio City are north of the Hollywood Hills. Burbank Airport (BUR) is a major regional airport. The 101, 134, and 5 connect the Valley to LAX.",
        hub: { name: "Burbank", route: "/cities/burbank" },
        communities: [
          { name: "Glendale", route: "/cities/glendale" }, { name: "Pasadena", route: "/cities/pasadena" },
          { name: "Studio City", route: "#" }, { name: "Sherman Oaks", route: "#" },
          { name: "Encino", route: "#" }, { name: "Tarzana", route: "#" },
          { name: "Woodland Hills", route: "#" }, { name: "Calabasas", route: "#" },
          { name: "Hidden Hills", route: "#" }, { name: "Agoura Hills", route: "#" },
          { name: "Westlake Village", route: "#" }, { name: "Thousand Oaks", route: "/cities/thousand-oaks" },
          { name: "Simi Valley", route: "/cities/simi-valley" }, { name: "Moorpark", route: "#" },
        ],
      },
      {
        name: "Orange County & South LA",
        description: "Anaheim, Santa Ana, Irvine, Huntington Beach, and Newport Beach form the OC core. John Wayne Airport (SNA) is centrally located. The 5, 405, and 55 freeways connect to LAX in 45–60 minutes.",
        hub: { name: "Irvine", route: "/cities/irvine" },
        communities: [
          { name: "Anaheim", route: "/cities/anaheim" }, { name: "Santa Ana", route: "/cities/santa-ana" },
          { name: "Costa Mesa", route: "/cities/costa-mesa" }, { name: "Newport Beach", route: "/cities/newport-beach" },
          { name: "Huntington Beach", route: "/cities/huntington-beach" }, { name: "Fountain Valley", route: "#" },
          { name: "Westminster", route: "#" }, { name: "Seal Beach", route: "#" },
          { name: "Tustin", route: "/cities/tustin" }, { name: "Lake Forest", route: "#" },
          { name: "Mission Viejo", route: "#" }, { name: "Laguna Beach", route: "#" },
          { name: "Dana Point", route: "#" }, { name: "San Clemente", route: "#" },
        ],
      },
      {
        name: "Downtown LA & Eastside",
        description: "Downtown LA, Arts District, Boyle Heights, and South LA. The 110 and 101 connect to LAX. Long Beach Airport (LGB) is an alternative for South LA residents. East LA and Alhambra are along the 10 corridor.",
        hub: { name: "Los Angeles", route: "/cities/los-angeles" },
        communities: [
          { name: "Long Beach", route: "/cities/long-beach" }, { name: "Signal Hill", route: "#" },
          { name: "Lakewood", route: "#" }, { name: "Carson", route: "#" },
          { name: "Torrance", route: "/cities/torrance" }, { name: "Gardena", route: "#" },
          { name: "Hawthorne", route: "#" }, { name: "Inglewood", route: "#" },
          { name: "Compton", route: "/cities/compton" }, { name: "Lynwood", route: "#" },
          { name: "South Gate", route: "#" }, { name: "Bellflower", route: "#" },
          { name: "Downey", route: "#" }, { name: "Norwalk", route: "#" },
        ],
      },
    ],
  },
  {
    id: "san-diego",
    name: "San Diego Area",
    icon: "ri-sun-line",
    subregions: [
      {
        name: "San Diego Coastal",
        description: "La Jolla, Pacific Beach, Mission Beach, and Point Loma are all along the 5. San Diego International (SAN) is directly on the harbor. Del Mar and Solana Beach are north on the 5; Coronado is across the bay.",
        hub: { name: "San Diego", route: "/cities/san-diego" },
        communities: [
          { name: "La Jolla", route: "#" }, { name: "Pacific Beach", route: "#" },
          { name: "Mission Beach", route: "#" }, { name: "Point Loma", route: "#" },
          { name: "Ocean Beach", route: "#" }, { name: "Coronado", route: "#" },
          { name: "Chula Vista", route: "/cities/chula-vista" }, { name: "National City", route: "#" },
          { name: "Imperial Beach", route: "#" }, { name: "Bonita", route: "#" },
          { name: "Del Mar", route: "#" }, { name: "Solana Beach", route: "#" },
        ],
      },
      {
        name: "North San Diego County",
        description: "Oceanside, Carlsbad, Vista, and Escondido are north on the 5 or 78. Camp Pendleton is the largest military installation in the US — military families need frequent passport services. Fallbrook is inland on the 76.",
        hub: { name: "Carlsbad", route: "/cities/carlsbad" },
        communities: [
          { name: "Oceanside", route: "/cities/oceanside" }, { name: "Vista", route: "#" },
          { name: "Escondido", route: "#" }, { name: "San Marcos", route: "#" },
          { name: "Poway", route: "#" }, { name: "Ramona", route: "#" },
          { name: "Fallbrook", route: "#" }, { name: "Bonsall", route: "#" },
          { name: "Valley Center", route: "#" }, { name: "Pala", route: "#" },
          { name: "Pauma Valley", route: "#" }, { name: "Rainbow", route: "#" },
        ],
      },
    ],
  },
  {
    id: "bay-area",
    name: "San Francisco Bay Area",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "San Francisco & Peninsula",
        description: "San Francisco, Daly City, South San Francisco, and Pacifica. SFO is south on the 101. The Peninsula communities (San Bruno, Millbrae, Burlingame) are directly adjacent to the airport.",
        hub: { name: "San Francisco", route: "/cities/san-francisco" },
        communities: [
          { name: "Daly City", route: "/cities/daly-city" }, { name: "South San Francisco", route: "#" },
          { name: "San Bruno", route: "#" }, { name: "Pacifica", route: "#" },
          { name: "Brisbane", route: "#" }, { name: "Millbrae", route: "#" },
          { name: "Burlingame", route: "#" }, { name: "San Mateo", route: "/cities/san-mateo" },
          { name: "Foster City", route: "#" }, { name: "Redwood City", route: "#" },
          { name: "Palo Alto", route: "#" }, { name: "Mountain View", route: "/cities/mountain-view" },
          { name: "Sunnyvale", route: "/cities/sunnyvale" }, { name: "Santa Clara", route: "#" },
        ],
      },
      {
        name: "East Bay",
        description: "Oakland, Berkeley, Richmond, Alameda, and Emeryville. The Bay Bridge connects to SF in 15 minutes. Oakland International (OAK) is the East Bay's airport. Vallejo and Fairfield are north on the 80.",
        hub: { name: "Oakland", route: "/cities/oakland" },
        communities: [
          { name: "Berkeley", route: "/cities/berkeley" }, { name: "Richmond", route: "#" },
          { name: "Alameda", route: "#" }, { name: "Emeryville", route: "#" },
          { name: "San Leandro", route: "#" }, { name: "Hayward", route: "#" },
          { name: "Union City", route: "#" }, { name: "Fremont", route: "#" },
          { name: "Castro Valley", route: "#" }, { name: "Pleasanton", route: "#" },
          { name: "Dublin", route: "#" }, { name: "Livermore", route: "/cities/livermore" },
          { name: "Walnut Creek", route: "#" }, { name: "Concord", route: "/cities/concord" },
        ],
      },
      {
        name: "South Bay & Silicon Valley",
        description: "San Jose, Cupertino, Los Gatos, and Saratoga — the heart of Silicon Valley. San Jose International (SJC) is the main airport. The 680, 880, and 101 form the major corridors.",
        hub: { name: "San Jose", route: "/cities/san-jose" },
        communities: [
          { name: "Cupertino", route: "#" }, { name: "Los Gatos", route: "#" },
          { name: "Saratoga", route: "#" }, { name: "Campbell", route: "#" },
          { name: "Milpitas", route: "#" }, { name: "Gilroy", route: "#" },
          { name: "Morgan Hill", route: "#" }, { name: "Santa Clara", route: "#" },
          { name: "Menlo Park", route: "#" }, { name: "Atherton", route: "#" },
          { name: "Woodside", route: "#" }, { name: "Portola Valley", route: "#" },
          { name: "Los Altos", route: "#" }, { name: "Los Altos Hills", route: "#" },
        ],
      },
    ],
  },
  {
    id: "central-northern",
    name: "Central & Northern CA",
    icon: "ri-landscape-line",
    subregions: [
      {
        name: "Central Valley",
        description: "Fresno, Bakersfield, Modesto, Stockton, and Visalia form the agricultural heart of California. Highway 99 runs the length of the valley. Fresno Yosemite International (FAT) is the valley's primary airport.",
        hub: { name: "Fresno", route: "/cities/fresno" },
        communities: [
          { name: "Bakersfield", route: "/cities/bakersfield" }, { name: "Modesto", route: "/cities/modesto" },
          { name: "Stockton", route: "/cities/stockton" }, { name: "Visalia", route: "/cities/visalia" },
          { name: "Tulare", route: "#" }, { name: "Porterville", route: "#" },
          { name: "Madera", route: "#" }, { name: "Hanford", route: "#" },
          { name: "Clovis", route: "#" }, { name: "Sanger", route: "#" },
          { name: "Reedley", route: "#" }, { name: "Selma", route: "#" },
          { name: "Lodi", route: "#" }, { name: "Tracy", route: "/cities/tracy" },
          { name: "Manteca", route: "#" }, { name: "Turlock", route: "#" },
        ],
      },
      {
        name: "Sacramento Valley",
        description: "Sacramento, Elk Grove, Roseville, Folsom, and Davis. Sacramento International (SMF) is the main airport. The 5, 80, and 50 connect the valley. The UC Davis community generates significant travel.",
        hub: { name: "Sacramento", route: "/cities/sacramento" },
        communities: [
          { name: "Elk Grove", route: "#" }, { name: "Roseville", route: "/cities/roseville" },
          { name: "Folsom", route: "#" }, { name: "Davis", route: "#" },
          { name: "Woodland", route: "#" }, { name: "West Sacramento", route: "#" },
          { name: "Rancho Cordova", route: "#" }, { name: "Citrus Heights", route: "#" },
          { name: "Carmichael", route: "#" }, { name: "Fair Oaks", route: "#" },
          { name: "Auburn", route: "#" }, { name: "Rocklin", route: "#" },
          { name: "Lincoln", route: "#" }, { name: "Placerville", route: "#" },
          { name: "Grass Valley", route: "#" }, { name: "Nevada City", route: "#" },
        ],
      },
      {
        name: "Wine Country & North Coast",
        description: "Santa Rosa, Sonoma, Napa, and Petaluma are the Wine Country core. The Russian River valley communities are a major tourist destination. Mendocino and Fort Bragg are the remote north coast.",
        hub: { name: "Santa Rosa", route: "/cities/santa-rosa" },
        communities: [
          { name: "Sonoma", route: "#" }, { name: "Napa", route: "#" },
          { name: "Petaluma", route: "#" }, { name: "Rohnert Park", route: "#" },
          { name: "Windsor", route: "#" }, { name: "Healdsburg", route: "#" },
          { name: "Cloverdale", route: "#" }, { name: "Sebastopol", route: "#" },
          { name: "Guerneville", route: "#" }, { name: "Mendocino", route: "#" },
          { name: "Fort Bragg", route: "#" }, { name: "Willits", route: "#" },
          { name: "Ukiah", route: "#" }, { name: "Lakeport", route: "#" },
          { name: "Clearlake", route: "#" }, { name: "Calistoga", route: "#" },
        ],
      },
    ],
  },
  {
    id: "inland-coastal",
    name: "Inland Empire & Coastal",
    icon: "ri-ship-line",
    subregions: [
      {
        name: "Inland Empire",
        description: "Riverside, San Bernardino, Ontario, Rancho Cucamonga, and Moreno Valley. Ontario International (ONT) is the IE's airport. The 15, 10, 91, and 210 freeways connect to LAX and Orange County.",
        hub: { name: "Riverside", route: "/cities/riverside" },
        communities: [
          { name: "San Bernardino", route: "/cities/san-bernardino" }, { name: "Ontario", route: "#" },
          { name: "Rancho Cucamonga", route: "/cities/rancho-cucamonga" }, { name: "Moreno Valley", route: "/cities/moreno-valley" },
          { name: "Fontana", route: "#" }, { name: "Corona", route: "#" },
          { name: "Norco", route: "#" }, { name: "Eastvale", route: "#" },
          { name: "Jurupa Valley", route: "#" }, { name: "Upland", route: "#" },
          { name: "Claremont", route: "#" }, { name: "Chino", route: "#" },
          { name: "Chino Hills", route: "#" }, { name: "Pomona", route: "/cities/pomona" },
          { name: "La Verne", route: "#" }, { name: "San Dimas", route: "#" },
        ],
      },
      {
        name: "Central Coast",
        description: "Santa Barbara, Ventura, Oxnard, Camarillo, and San Luis Obispo. Santa Barbara Municipal (SBA) is the coastal airport. US-101 runs the entire coast. Big Sur is the scenic stretch between Monterey and SLO.",
        hub: { name: "Santa Barbara", route: "/cities/santa-barbara" },
        communities: [
          { name: "Ventura", route: "/cities/ventura" }, { name: "Oxnard", route: "/cities/oxnard" },
          { name: "Camarillo", route: "#" }, { name: "Port Hueneme", route: "#" },
          { name: "Goleta", route: "#" }, { name: "Carpinteria", route: "#" },
          { name: "Montecito", route: "#" }, { name: "Summerland", route: "#" },
          { name: "San Luis Obispo", route: "#" }, { name: "Pismo Beach", route: "#" },
          { name: "Morro Bay", route: "#" }, { name: "Cayucos", route: "#" },
          { name: "Atascadero", route: "#" }, { name: "Paso Robles", route: "#" },
          { name: "Arroyo Grande", route: "#" }, { name: "Grover Beach", route: "#" },
        ],
      },
      {
        name: "Monterey & Salinas",
        description: "Monterey, Seaside, Marina, and Salinas are the Monterey Peninsula. Monterey Regional (MRY) is the local airport. The 68 and 101 connect. Carmel-by-the-Sea and Pacific Grove are the coastal gems.",
        hub: { name: "Salinas", route: "/cities/salinas" },
        communities: [
          { name: "Monterey", route: "#" }, { name: "Seaside", route: "#" },
          { name: "Marina", route: "#" }, { name: "Carmel-by-the-Sea", route: "#" },
          { name: "Pacific Grove", route: "#" }, { name: "Del Rey Oaks", route: "#" },
          { name: "Sand City", route: "#" }, { name: "Gonzales", route: "#" },
          { name: "Soledad", route: "#" }, { name: "King City", route: "#" },
          { name: "Greenfield", route: "#" }, { name: "Watsonville", route: "#" },
          { name: "Aptos", route: "#" }, { name: "Capitola", route: "#" },
          { name: "Scotts Valley", route: "#" }, { name: "Felton", route: "#" },
        ],
      },
    ],
  },
];

export default function CaliforniaCommunitiesWeServe() {
  const [activeRegion, setActiveRegion] = useState(regions[0].id);

  const current = regions.find((r) => r.id === activeRegion) || regions[0];

  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Statewide Coverage
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Communities We Serve Across California
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Don't see your city in the directory above? You're still covered. Every California community below is served through our nearest hub — with the same fast, reliable expedited passport processing.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setActiveRegion(region.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeRegion === region.id
                  ? "bg-[#1A365D] text-white"
                  : "bg-[#EEF2F8] text-[#1A365D] hover:bg-[#dce5f3]"
              }`}
            >
              <i className={`${region.icon} text-base`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {current.subregions.map((sub, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start justify-between gap-4 mb-3">
                <h3 className="font-bold text-[#1A365D] text-base">{sub.name}</h3>
                {sub.hub.route !== "#" ? (
                  <a
                    href={sub.hub.route}
                    className="flex-shrink-0 inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap"
                  >
                    Hub: {sub.hub.name} <i className="ri-arrow-right-line"></i>
                  </a>
                ) : (
                  <span className="flex-shrink-0 inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                    Hub: {sub.hub.name}
                  </span>
                )}
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{sub.description}</p>
              <div className="flex flex-wrap gap-2">
                {sub.communities.map((c, j) => (
                  c.route !== "#" ? (
                    <a
                      key={j}
                      href={c.route}
                      className="inline-flex items-center text-xs font-medium text-[#1A365D] bg-white border border-gray-200 rounded-full px-3 py-1 hover:border-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap cursor-pointer"
                    >
                      {c.name}
                    </a>
                  ) : (
                    <span
                      key={j}
                      className="inline-flex items-center text-xs font-medium text-[#6B7280] bg-white border border-gray-200 rounded-full px-3 py-1 whitespace-nowrap"
                    >
                      {c.name}
                    </span>
                  )
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Not finding your exact community? <a href="tel:8772530084" className="text-[#1A365D] font-semibold hover:text-[#F6C344] transition-colors">Call us at 877-253-0084</a> — we serve all of California.
        </p>
      </div>
    </section>
  );
}